// extracted by mini-css-extract-plugin
export default {"burger":"header-burger_burger__RwZEx","burger__line":"header-burger_burger__line__uHfuf","open":"header-burger_open__nMRbH"};